import { RobotTextResources } from "@portal/assets/text/RobotTextResources";

export const ExpectedValueData = (
  managmentFees: number[],
  depotFees: number[],
  portfolioValues: number[],
  isDefaultLanguage: boolean,
  dates: string[],
) => {
  const yMargin = 250;
  const yMaxValue = (portfolioValues[2] ?? 0) + yMargin;
  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;

  return {
    chart: { type: "column" },
    credits: { enabled: false },
    title: null,
    accessibility: { enabled: false },
    xAxis: { type: "category" },
    yAxis: { title: null, minRange: 0, maxRange: yMaxValue },
    legend: { itemStyle: { fontSize: "12px" }, redraw: true },
    plotOptions: {
      column: { stacking: "normal" },
      series: { borderWidth: 0, dataLabels: { enabled: false } },
    },
    tooltip: {
      headerFormat: '<span style="font-size:12px">{series.name}</span><br>',
      pointFormat:
        '<span style="color:{point.color}; font-size:12px">{point.name} </span><span style="font-size:12px">{point.y:.2f}</span>',
    },
    series: [
      {
        name: `${texts.PAGE_15_DEPOT}`,
        data: [depotFees[0], depotFees[1], depotFees[2]],
      },
      {
        name: `${texts.PAGE_15_COMMISION}`,
        data: [managmentFees[0], managmentFees[1], managmentFees[2]],
      },
      {
        name: `${texts.PAGE_15_VALUE_TOTAL}`,
        data: [
          { name: dates[0], y: portfolioValues[0] },
          { name: dates[1], y: portfolioValues[1] },
          { name: dates[2], y: portfolioValues[2] },
        ],
      },
    ],
  };
};
